import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import {  HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
export const SocialLinks = () => {
    const links=[
        {
            id:1,
            child:(
                <>
                    LinkdIn<FaLinkedin size={30}   /> 
                </>

            ),
            href:"https://www.linkedin.com/in/vishnu-jangid-468274218/",
            style:"rounded-tr-md"
        },
        {
            id:2,
            child:(
                <>
                    GitHub<FaGithub size={30}   /> 
                </>

            ),
            href:"https://github.com/Vis01",
        },
        {
            id:3,
            child:(
                <>
                    Mail<HiOutlineMail size={30}   /> 
                </>

            ),
            href:"mailto:vishnu.j8503@gmail.com ",
        },
        {
            id:4,
            child:(
                <>
                    Resume<BsFillPersonLinesFill size={30}   /> 
                </>

            ),
            href:"/resume.pdf",
            style:"rounded-br-md",
            download:true,
        },
    ]

  return (
    <div className="lg:flex flex-col opacity-70 top-[35%] left-0 fixed">
      <ul>

        {links.map(({id,child,href,style,download})=> (
             <li key={id}
                 className={`flex justify-between itwms-center w-40 h-14 px-4 ml-[-100px] hover:rounded-md duration-300 hover:ml-[-10px]  bg-gray-500 ${style} `}
           >
             <a
               href={href}
               className="flex justify-between items-center w-full
                        text-white "
               download={download}
               target='_blank'
               rel="noreferrer"
             >
                {child}
             </a>
           </li>

        ))}

       
      </ul>
    </div>
  );
};
